import { reduxForm, submit } from 'redux-form'
import { connect } from 'react-redux'
import { message } from 'antd';
import { updateVehicle, deleteVehicle } from './actions'
// LOCAL
import Vehicle from './Vehicle'

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: state.models.vehicles.find((v)=>v.token_id==ownProps.match.params.vehicleId),
    buttonTitle: 'Update',
    title: 'Update Vehicle'
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemoteSubmit: () => dispatch(submit('updateVehicle')),
    onDelete: () => dispatch(deleteVehicle(ownProps.match.params.vehicleId))
      .then(()=>message.success('Deleted vehicle successfully', 4))
  }
}

const Update = reduxForm({
  form: 'updateVehicle',
  onSubmit: (values, dispatch)=> dispatch(updateVehicle(values))
})(Vehicle)

export default connect(mapStateToProps, mapDispatchToProps)(Update)



// WEBPACK FOOTER //
// ./src/account/vehicles/Update.js